// extracted by mini-css-extract-plugin
export default {"drawer":"Drawer_drawer__aGX1n","drawerHeader":"Drawer_drawerHeader__Qw2wm"};